"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Static = require("./Static");
Object.keys(_Static).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Static[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Static[key];
    }
  });
});